<template>
  <div class="animated fadeIn form-abm">
    <b-row>
      <b-col xl="12">
        <b-card header= "Datos de la Participación">
          <b-form>
            <b-form-group
              label="Código"
              label-for="codigoPromocion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigoPromocion"
                v-model.trim="$v.codigoPromocion.$model" 
                :state="codigoPromocionValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="codigoPromocionFeedback">
                {{ codigoPromocionInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <b-form-group
              label="Nro.Documento"
              label-for="documentoNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="documentoNumero"
                v-model.trim="$v.documentoNumero.$model" 
                :state="documentoNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="documentoNumeroFeedback">
                {{ documentoNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group> -->

            <b-form-group
              label="CUIT"
              label-for="cuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cuit"
                v-model.trim="$v.cuit.$model" 
                :state="cuitValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cuitFeedback">
                {{ cuitInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, requiredIf, numeric, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'participanteReinscripcion/getField',
  mutationType: 'participanteReinscripcion/updateField',
});

export default {
  name: 'ParticipanteReinscripcion',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      eventoId: 0,

      noValidar: true,
      codigoPromocionValido: null,
      codigoPromocionInvalidoMsj: '',
      cuitValido: null,
      cuitInvalidoMsj: '',

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'codigoPromocion',
      'cuit'
    ]),
  },  
  created() {
    if (this.$route.params){
      if (this.$route.params.eventoId){
        this.eventoId = this.$route.params.eventoId;
      }
    }

    this.showSpinner();
    this.$store.dispatch('participanteReinscripcion/inicializar', this.eventoId)
      // .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'codigoPromocion' || validarTodos) {
        if (this.$v.codigoPromocion.$error) {
          this.codigoPromocionValido = false;
          if (!this.$v.codigoPromocion.required) {
            this.codigoPromocionInvalidoMsj= 'Debe ingresar el código de promoción.';
          } else if (!this.$v.codigoPromocion.maxLength) {
            this.codigoPromocionInvalidoMsj = 'El código de promoción solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.codigoPromocionValido = null;
          this.codigoPromocionInvalidoMsj = '';
        }
      }

      // if (campo == 'documentoNumero' || validarTodos) {
      //   if (this.$v.documentoNumero.$error) {
      //     this.documentoNumeroValido = false;
      //     if (!this.$v.documentoNumero.required) {
      //       this.documentoNumeroInvalidoMsj= 'Debe ingresar el número de documento.';
      //     } else if (!this.$v.documentoNumero.maxLength) {
      //       this.documentoNumeroInvalidoMsj = 'El número de documento solo puede contener hasta 50 caracteres';
      //     } 
      //   } else {
      //     this.documentoNumeroValido = null;
      //     this.documentoNumeroInvalidoMsj = '';
      //   }
      // }

      if (campo == 'cuit' || validarTodos) {
        if (this.$v.cuit.$error) {
          this.cuitValido = false;
          if (!this.$v.cuit.required) {
            this.cuitInvalidoMsj= 'Debe ingresar el CUIT del negocio.';
          } else if (!this.$v.cuit.maxLength) {
            this.cuitInvalidoMsj = 'El CUIT solo puede contener hasta 15 caracteres';
          } 
        } else {
          this.cuitValido = null;
          this.cuitInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('participanteReinscripcion/getParticipanteReinscripcion')
            .then(() => this.goConfirmacion())
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        } 
      }
    },
    goConfirmacion() {
      this.$router.push({ name: 'ParticipanteReinscripcionConfirmacion' });
    },
    goList() {
      this.$router.push({ name: 'Participantes', 
                          params: { eventoId: this.eventoId }});
    },
  },
  watch: {
  },
  validations: {
    // documentoNumero: {
    //   required: requiredIf(function () {
    //     return (/true/i).test(this.eventoRequiereDocumento);
    //   }),
    //   maxLength: maxLength(50)
    // },
    codigoPromocion: {
      required,
      // required: requiredIf(function () {
      //   if ((/true/i).test(this.eventoRequiereCodigoPromocion)) {
      //     return true;
      //   }
      //   return false;
      // }),
      maxLength: maxLength(255)
    },
    cuit: {
      required,
      // required: requiredIf(function () {
      //   if ((/true/i).test(this.eventoParticipacionNegocios)) {
      //     return true;
      //   }
      //   return false;
      // }),
      maxLength: maxLength(15)
    },
  },  
}
</script>

<style>
</style>
